import {PropsWithChildren, useState} from "react";

import Button from "@/components/button/Button.tsx";
import {ButtonVariant} from "@/components/button/Button.types.ts";
import {PropsWithClassName} from "@/lib/types/props.ts";
import {AddExternalUserModal} from "@/pages/statuspages/tabs/external-users/components/AddExternalUserModal.tsx";

interface AddExternalUserButtonProps extends PropsWithChildren, PropsWithClassName {
  statusPageID: number;
  variant?: ButtonVariant;
}

export const AddExternalUserButton = ({statusPageID, className, children, variant}: AddExternalUserButtonProps) => {
  const [show, setShow] = useState<boolean>(false);
  return (
    <>
      <Button
        className={className}
        variant={variant}
        onClick={() => {
          setShow(true);
        }}
      >
        {children}
      </Button>
      {show && <AddExternalUserModal setShow={setShow} statusPageID={statusPageID} />}
    </>
  );
};
